import React, { useEffect } from "react";
import SearchAndCheckboxList from "../../components/SearchAndCheckboxList";
import OutputFieldList from "../../components/OutputFieldList";
import "../../css/AgentSelectorFields.css";
import { useDispatch, useSelector } from "react-redux";
import {
  saveFormDetails,
  saveOutPutOcrFinalFields,
} from "../../redux/slices/CreateAgentSlice";
import { FORM_KEYS } from "../../utills/constant";
import { getOcrFields } from "../../redux/slices/ActiveSystemAiAgentLists";
import {  Skeleton } from "@mui/material";
import CsvFileScreen from "./CsvFileScreen";

const AgentSelectorFields = ({ slug }) => {
  const { activieSystemAiOcrFields, ocrFieldsLoading } = useSelector(
    (state) => state.ActiveSystemAiAgentLists
  );
  const {getCsvLoading,csvUpdateLoading} = useSelector((state) => state.CSVDataSlice);
  const formDetails = useSelector(
    (state) => state.CreateAgentSlice.formDetails
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (slug === "invoice") {
      dispatch(getOcrFields(slug));
    }
  }, [slug]);

  // Agent List Component with Skeleton
  const loading = () => {
    if (ocrFieldsLoading || getCsvLoading) {
      return (
        <div className="agent-list-container">
          {[...Array(4)].map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width={200}
              height={120}
              sx={{ borderRadius: "8px", marginBottom: "16px" }}
            />
          ))}
        </div>
      );
    }
  };

  const handleGetSelectedItems = (selectedItems) => {
    const selectedData = selectedItems.map((item) => ({
      key: item.keys,
      label: item.label,
    }));
    dispatch(saveOutPutOcrFinalFields(selectedData));
    dispatch(
      saveFormDetails({ key: FORM_KEYS.OCR_FIELDS, value: selectedData })
    );
  };

  return ocrFieldsLoading || getCsvLoading || csvUpdateLoading ? (
    loading()
  ) : (
    <div className="agent-selector-container">
      {slug !== "moad-so" && slug !== "extract-iq"? (
        <>
          {/* INPUT FIELDS */}
          <div className="field-section">
            <h2 className="field-title">INPUT FIELDS</h2>
            <SearchAndCheckboxList
              data={activieSystemAiOcrFields?.ocr_fields}
              getSelectedItems={(data) => handleGetSelectedItems(data)}
            />
          </div>

          {/* OUTPUT FIELDS */}
          <div className="field-section field-section-output">
            <h2 className="field-title">OUTPUT FIELDS</h2>
            {formDetails[FORM_KEYS.OCR_FIELDS] && (
              <OutputFieldList
                isOutput={true}
                getSelectedItems={handleGetSelectedItems}
              />
            )}
          </div>
        </>
      ) : (
        <CsvFileScreen />
      )}
    </div>
  );
};

export default AgentSelectorFields;
